function datePick01() {

    const delivery_date = document.getElementById('date__visitstore__page')
        , max_date = delivery_date ? delivery_date.getAttribute('max-date') : 7
        , min_date = delivery_date ? delivery_date.getAttribute('min-date') : 3;

    let minDate = new Date;
    minDate.getDay() === 0 || minDate.getDay() === 1 || minDate.getDay() === 6
                      ? minDate2 = minDate.getDate() + Number(min_date) + 1
                      : minDate2 = minDate.getDate() + Number(min_date),
    minDate = minDate.setDate(minDate2);

    flatpickr(".flatpickr01", {
        locale: "ja",
        disableMobile: !0,
        dateFormat: "Y/m/d\uFF08D\uFF09",
        minDate,
        maxDate: new Date().fp_incr(max_date),
        disable: [function(date) {
            return date.getDay() === 2
        }
        ]
    })
}
function datePick02() {
    const delivery_date = document.getElementById('date__deliveryhome__page')
        , max_date = delivery_date ? delivery_date.getAttribute('max-date') : 14
        , min_date = delivery_date ? delivery_date.getAttribute('min-date') : 7;

    flatpickr(".flatpickr02", {
        locale: "ja",
        disableMobile: !0,
        dateFormat: "Y/m/d\uFF08D\uFF09",
        minDate: new Date().fp_incr(min_date),
        maxDate: new Date().fp_incr(max_date)
    })
}
var AnchorList = []
  , SSIDList = []
  , aTag = document.getElementsByTagName("a")
  , AList = Array.from(aTag)
  , sectionBlock = document.getElementsByClassName("shopify-section")
  , SBList = Array.from(sectionBlock);
AList.forEach(Ahref=>{
    Ahref.classList.contains("scroll") && AnchorList.push(Ahref)
}
),
SBList.forEach(SBID=>{
    SBID.id.match(/shopify-section-template--/) && (SBID = SBID.id,
    SSIDList.push(SBID))
}
),
AnchorList.forEach(aAnchor=>{
    var nowURL = location.href
      , aID = aAnchor.href
      , aAnchorTxt = aID.replace(nowURL + "#", "");
    SSIDList.forEach(SSID=>{
        SSID.match(aAnchorTxt) && aAnchor.setAttribute("href", "#" + SSID)
    }
    )
}
);

function clearDateTimeDrawer() {
    var visitstoreDrawer = document.getElementById("visitstore__drawer")
      , VDA01 = document.getElementById("visitstore__drawer__attention01")
      , VDA02 = document.getElementById("visitstore__drawer__attention02")
      , DVD = document.getElementById("date__visitstore__drawer")
      , TVD = document.getElementById("time__visitstore__drawer")
      , addressZipDrawer = document.getElementById("address__zip__drawer")
      , addressPrefectureDrawer = document.getElementById("address__prefecture__drawer")
      , addressAreaDrawer = document.getElementById("address__area__drawer")
      , addressAddrDrawer = document.getElementById("address__addr__drawer")
      , addressBuildingDrawer = document.getElementById("address__building__drawer")
      , addressTelDrawer = document.getElementById("address__tel__drawer")
      , deliveryhomeDrawer = document.getElementById("deliveryhome__drawer")
      , DDD = document.getElementById("date__deliveryhome__drawer")
      , TDD = document.getElementById("time__deliveryhome__drawer")
      , btnCart = document.getElementById("CartDrawer-Cart")
      , btnCheckout = document.getElementById("CartDrawer-Checkout")
      , cartitemCover = document.getElementById("cart-items__cover")
      , cartitemCount = cartitemCover.childElementCount;
    console.log(cartitemCount);
    function setVSDD() {
        DVD.setAttribute("disabled", !0),
        TVD.setAttribute("disabled", !0)
    }
    function removeVSDD() {
        DVD.removeAttribute("disabled"),
        TVD.removeAttribute("disabled")
    }
    function setVSAD() {
        addressZipDrawer.setAttribute("disabled", !0),
        addressPrefectureDrawer.setAttribute("disabled", !0),
        addressAreaDrawer.setAttribute("disabled", !0),
        addressAddrDrawer.setAttribute("disabled", !0),
        addressBuildingDrawer.setAttribute("disabled", !0),
        addressTelDrawer.setAttribute("disabled", !0),
        btnCart.setAttribute("disabled", !0),
        btnCheckout.setAttribute("disabled", !0)
    }
    function removeVSAD() {
        addressZipDrawer.removeAttribute("disabled"),
        addressPrefectureDrawer.removeAttribute("disabled"),
        addressAreaDrawer.removeAttribute("disabled"),
        addressAddrDrawer.removeAttribute("disabled"),
        addressBuildingDrawer.removeAttribute("disabled"),
        addressTelDrawer.removeAttribute("disabled")
    }
    function setBtnD() {
        btnCart.setAttribute("disabled", !0),
        btnCheckout.setAttribute("disabled", !0)
    }
    function removeBtnD() {
        btnCart.removeAttribute("disabled"),
        btnCheckout.removeAttribute("disabled")
    }
    function inputAddressDrawer() {
        let gUrlDrawer = "https://maps.googleapis.com/maps/api/geocode/json?address=" + addressZipDrawer.value + "&language=ja&key=AIzaSyCY_NCiYIeSixpOfsH42LTE1SdXrxLyoWw"
          , zipAttentionDrawer = document.getElementById("zip-error-drawer");
        fetch(gUrlDrawer).then(response=>response.json()).then(data=>{
            zipAttentionDrawer.textContent = "";
            var AddDataLength = data.results.length, AddData = data.results[0].address_components, AddDataPrefecture;
            function selectPrefectureDrawer() {
                for (PDL = 0; PDL < addressPrefectureDrawer.options.length; PDL++) {
                    var PValue = addressPrefectureDrawer.options[PDL].value;
                    AddDataPrefecture == PValue && (addressPrefectureDrawer.selectedIndex = PDL)
                }
            }
            AddData.length == 3 ? (AddDataPrefecture = AddData[1].long_name,
            selectPrefectureDrawer(),
            addressAreaDrawer.value = "",
            addressAddrDrawer.value = "") : AddData.length == 4 ? (AddDataPrefecture = AddData[2].long_name,
            selectPrefectureDrawer(),
            addressAreaDrawer.value = AddData[1].long_name,
            addressAddrDrawer.value = "") : AddData.length == 5 ? (AddDataPrefecture = AddData[3].long_name,
            selectPrefectureDrawer(),
            addressAreaDrawer.value = AddData[2].long_name,
            addressAddrDrawer.value = AddData[1].long_name) : AddData.length == 6 && (AddDataPrefecture = AddData[4].long_name,
            selectPrefectureDrawer(),
            addressAreaDrawer.value = AddData[3].long_name,
            addressAddrDrawer.value = AddData[2].long_name + AddData[1].long_name)
        }
        ).catch(error=>{
            console.error("\u901A\u4FE1\u306B\u5931\u6557\u3057\u307E\u3057\u305F", error),
            zipAttentionDrawer.textContent = "\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u3002\u4F4F\u6240\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
            addressPrefectureDrawer.selectedIndex = 0,
            addressAreaDrawer.value = "",
            addressAddrDrawer.value = ""
        }
        )
    }
    function checkcartItemNum() {
        var cartitemCover2 = document.getElementById("cart-items__cover")
          , cartitemCount2 = cartitemCover2.childElementCount;
        console.log(cartitemCount2),
        cartitemCount2 > 1 ? setBtnD() : removeBtnD()
    }
    visitstoreDrawer.addEventListener("change", function() {
        this.checked == !0 && (DDD.value = "",
        TDD.selectedIndex = 0,
        VDA01.removeAttribute("disabled"),
        VDA02.removeAttribute("disabled"),
        setBtnD())
    }),
    VDA01.addEventListener("change", function() {
        this.checked == !0 && VDA02.checked == !0 ? (removeVSDD(),
        removeVSAD(),
        DVD.value !== "" && TVD.value !== "" && addressZipDrawer.value !== "" && addressPrefectureDrawer.value !== "" && addressAreaDrawer.value !== "" && addressAddrDrawer.value !== "" && addressTelDrawer.value !== "" && cartitemCount === 1 ? removeBtnD() : setBtnD()) : (setVSDD(),
        setVSAD(),
        setBtnD())
    }),
    VDA02.addEventListener("change", function() {
        this.checked == !0 && VDA01.checked == !0 ? (removeVSDD(),
        removeVSAD(),
        DVD.value !== "" && TVD.value !== "" && addressZipDrawer.value !== "" && addressPrefectureDrawer.value !== "" && addressAreaDrawer.value !== "" && addressAddrDrawer.value !== "" && addressTelDrawer.value !== "" && cartitemCount === 1 ? removeBtnD() : setBtnD()) : (setVSDD(),
        setVSAD(),
        setBtnD())
    }),
    DVD.addEventListener("change", function() {
        this.value === "" && TVD.value === "" && addressZipDrawer.value === "" && addressPrefectureDrawer.value === "" && addressAreaDrawer.value === "" && addressAddrDrawer.value === "" && addressTelDrawer.value === "" && cartitemCount > 1 || this.value === "" || TVD.value === "" || addressZipDrawer.value === "" || addressPrefectureDrawer.value === "" || addressAreaDrawer.value === "" || addressAddrDrawer.value === "" || addressTelDrawer.value === "" || cartitemCount > 1 ? setBtnD() : removeBtnD()
    }),
    TVD.addEventListener("change", function() {
        this.value === "" && DVD.value === "" && addressZipDrawer.value === "" && addressPrefectureDrawer.value === "" && addressAreaDrawer.value === "" && addressAddrDrawer.value === "" && addressTelDrawer.value === "" && cartitemCount > 1 || this.value === "" || DVD.value === "" || addressZipDrawer.value === "" || addressPrefectureDrawer.value === "" || addressAreaDrawer.value === "" || addressAddrDrawer.value === "" || addressTelDrawer.value === "" || cartitemCount > 1 ? setBtnD() : removeBtnD()
    }),
    addressZipDrawer.addEventListener("input", function() {
        DVD.value === "" && TVD.value === "" && this.value === "" && addressPrefectureDrawer.value === "" && addressAreaDrawer.value === "" && addressAddrDrawer.value === "" && addressTelDrawer.value === "" && cartitemCount > 1 || DVD.value === "" || TVD.value === "" || this.value === "" || addressPrefectureDrawer.value === "" || addressAreaDrawer.value === "" || addressAddrDrawer.value === "" || addressTelDrawer.value === "" || cartitemCount > 1 ? setBtnD() : removeBtnD(),
        setTimeout(function() {
            inputAddressDrawer()
        }, 2e3)
    }),
    addressPrefectureDrawer.addEventListener("change", function() {
        DVD.value === "" && TVD.value === "" && addressZipDrawer.value === "" && this.value === "" && addressAreaDrawer.value === "" && addressAddrDrawer.value === "" && addressTelDrawer.value === "" && cartitemCount > 1 || DVD.value === "" || TVD.value === "" || addressZipDrawer.value === "" || this.value === "" || addressAreaDrawer.value === "" || addressAddrDrawer.value === "" || addressTelDrawer.value === "" || cartitemCount > 1 ? setBtnD() : removeBtnD()
    }),
    addressAreaDrawer.addEventListener("input", function() {
        DVD.value === "" && TVD.value === "" && addressZipDrawer.value === "" && addressPrefectureDrawer.value === "" && this.value === "" && addressAddrDrawer.value === "" && addressTelDrawer.value === "" && cartitemCount > 1 || DVD.value === "" || TVD.value === "" || addressZipDrawer.value === "" || addressPrefectureDrawer.value === "" || this.value === "" || addressAddrDrawer.value === "" || addressTelDrawer.value === "" || cartitemCount > 1 ? setBtnD() : removeBtnD()
    }),
    addressAddrDrawer.addEventListener("input", function() {
        DVD.value === "" && TVD.value === "" && addressZipDrawer.value === "" && addressPrefectureDrawer.value === "" && addressAreaDrawer.value === "" && this.value === "" && addressTelDrawer.value === "" && cartitemCount > 1 || DVD.value === "" || TVD.value === "" || addressZipDrawer.value === "" || addressPrefectureDrawer.value === "" || addressAreaDrawer.value === "" || this.value === "" || addressTelDrawer.value === "" || cartitemCount > 1 ? setBtnD() : removeBtnD()
    }),
    addressTelDrawer.addEventListener("input", function() {
        DVD.value === "" && TVD.value === "" && addressZipDrawer.value === "" && addressPrefectureDrawer.value === "" && addressAreaDrawer.value === "" && addressTelDrawer.value === "" && this.value === "" && cartitemCount > 1 || DVD.value === "" || TVD.value === "" || addressZipDrawer.value === "" || addressPrefectureDrawer.value === "" || addressAreaDrawer.value === "" || addressTelDrawer.value === "" || this.value === "" || cartitemCount > 1 ? setBtnD() : removeBtnD()
    }),
    deliveryhomeDrawer.addEventListener("change", function() {
        this.checked == !0 && cartitemCount === 1 && (DVD.value = "",
        TVD.selectedIndex = 0,
        VDA01.checked = !1,
        VDA02.checked = !1,
        VDA01.setAttribute("disabled", !0),
        VDA02.setAttribute("disabled", !0),
        addressZipDrawer.value = "",
        addressPrefectureDrawer.selectedIndex = 0,
        addressAreaDrawer.value = "",
        addressAddrDrawer.value = "",
        addressBuildingDrawer.value = "",
        addressTelDrawer.value = "",
        setVSDD(),
        setVSAD(),
        removeBtnD())
    })
}
//# sourceMappingURL=/cdn/shop/t/29/assets/common.js.map?v=17308781507676877321719191655